import moment from "moment";
import React from 'react'
const json = {
    search: '',
    gender: '',
    id: '',
    admission_date: moment(new Date()).format("DD-MM-YYYY"),
    discharge_date: moment(new Date()).format("DD-MM-YYYY"),
    admission_number:'',
    admission_id : '',
    chief_complaint:'',
    primary_a:'',
    primary_b:'',
    breathing_managements:'',
    hr:'',
    pr:'',
    rr:'',
    bp:'',
    bt:'',
    sat:'',
    primary_c:'',
    heart_sound:'',
    active_bleeding:'',
    managements:'',
    inv_eFAST:'',
    inv_ekg:'',
    gcs_e:'',
    gcs_v:'',
    gcs_m:'',
    pupil_response:'',
    primary_e:'',
    spine_alignment:'',
    pr2:'',
    ng_og_tube:'',
    inv_p_cxr:'',
    abg:'',
    alcohol_history:'',
    medication:'',
    past_illness_pregnancy:'',
    events:'',
    last_meal:'',
    head_neck:'',
    heart_lungs:'',
    abdomen_pelvis:'',
    extremities:'',
    per_rectal_exam:'',
    neurologic:'',
    remark_secondary_survey:'',
    investigations:'',
    primary_diagnosis:'',
    other_problems:'',
    plan_of_managements:'',
    search_admission : '',
    name : '',
    surname : '',
    hn : '',
    an : '',
    fractures_deformities : '',
    urethral_cath : '',
    allergy : '',
    head_neck_remark:'',
    heart_lungs_remark:'',
    abdomen_pelvis_remark:'',
    extremities_remark:'',
    per_rectal_exam_remark:'',
    neurologic_remark:'',
    restriction_cspine_motion:'',
    airway_managements:'',
    ward:'',
    height: '',
    weight: '',
    staff_name :'',
    staff_id :'',
    resident_name :'',
    division :'Trauma',
    record_name :'',
    recode_code :'',
    record_datetime :  moment(new Date()).add(7, 'hours').format("DD-MM-YYYY H:mm"),
    age : 0,
    fractures_deformities_remark:'',
    active_bleeding_remark:'',
    bp_d:'',
    bp_s:''


}

export default json;
